module.exports = __webpack_public_path__ + "img/saum_reinorange_ral2004.5b765b7f.jpg";